module.exports = __webpack_public_path__ + "img/qiyeshibai.168dbb36.png";